export default "__VITE_ASSET__0f483c15__"